import { createStore, withProps } from '@ngneat/elf';

import { MaintenanceStatus } from '~shared/types/maintenance.types';

export const maintenanceStore = createStore(
	{ name: 'maintenance' },
	withProps<MaintenanceStatus>({
		enabled: false,
		message: null,
		endsAt: null,
	})
);